import axios from 'axios'
import Vue from 'vue'

// Vue 2 compatible observable shared state
const state = Vue.observable({
  emotes: null,
  channel: null,
  badges: null,
  loading: false,
  error: null,
})

export default function useTwitch() {
  async function fetchEmotes() {
    state.loading = true
    state.error = null
    try {
      const r = await axios.get('/api/twitch/emotes')
      state.emotes = r.data
    } catch (e) {
      state.error = e
    } finally {
      state.loading = false
    }
  }

  async function fetchChannel() {
    state.loading = true
    state.error = null
    try {
      const r = await axios.get('/api/twitch/channel')
      state.channel = r.data
    } catch (e) {
      state.error = e
    } finally {
      state.loading = false
    }
  }

  async function fetchBadges() {
    state.loading = true
    state.error = null
    try {
      const r = await axios.get('/api/twitch/badges')
      state.badges = r.data
    } catch (e) {
      state.error = e
    } finally {
      state.loading = false
    }
  }

  return {
    state,
    fetchEmotes,
    fetchChannel,
    fetchBadges,
  }
} 
